export const emptyArray = Object.freeze([]);
